import DragScroll from './DragScroll';

export default class FloatingBar {
    constructor() {
        this.addEvents();
    }

    addEvents() {

        countSearchItem();

        new DragScroll('.floating-cpt__head--left');

        if(!sessionStorage.getItem("floatingBar")){
            $('.notauth-bar').removeClass('hide');
        }

        $('.notauth-bar__exit').on('click', function (e){
            e.preventDefault();
            $('.notauth-bar').addClass('hide');
            sessionStorage.setItem('floatingBar', true);
        })

        $(document).on('click', function(event) {
            if (
                !$(event.target).closest('.floating-bar').length &&
                !$(event.target).closest('.floating-cpt').length &&
                $(window).width() >= 768
                && $('.myAccount__popup.active').length == 0
            ) {
                $('.floating-bar, .floating-cpt').removeClass('active');
            }
        });


        $('.floating-bar__icon').on('click', function (e){
            e.preventDefault()
            if($('.floating-bar').hasClass('active')){
                $('.floating-bar, .floating-cpt, .floating-cpt__item, .floating-bar__list div').removeClass('active')
            }else{
                $('.floating-bar, .floating-cpt').addClass('active');
            }
        })

        $('.floating-cpt__subitem').on('click', function (e) {
            e.preventDefault();
            let index = $(this).index() + 1;
            $(this).parents('.floating-cpt__head--left').find('.floating-cpt__subitem').removeClass('active');
            $(this).addClass('active');

            this.scrollIntoView({
                behavior: 'smooth',
                inline: 'center'
            });

            let parent = $(this).parents('.floating-cpt__item.active');
            parent.find('.floating-cpt__content .floating-cpt__content--item').removeClass('active');

            if($(this).parents('.floating-cpt__head--left').find('.floating-cpt__subitem[data-start="true"]').length> 0){
                index--;
            }

            if($(this).attr('data-start') == 'true'){
                $('.myAccount__start').addClass('active');
            }else{
                $('.myAccount__start').removeClass('active');
            }

            parent.find('.floating-cpt__content .floating-cpt__content--item:nth-child('+index+')').addClass('active');
            checkEmpty();
        });


        $('.floating-bar .floating-bar__list div').on('click', function (e){
            e.preventDefault();
            let suffix = $('html').attr('lang') == 'he-IL' ? 'he/' : '';
            if($(window).width() <= 768){
                window.location = '/'+suffix+'my-account/?tab='+$(this).attr('data-tab');
            }else{
                let index = $(this).index() + 1;
                $('.floating-bar .floating-bar__list div').removeClass('active');
                $(this).addClass('active');
                $('.floating-cpt__item.active').removeClass('active');
                $('.floating-cpt__item:nth-child('+index+')').addClass('active');

                if($('.floating-cpt__item.active .floating-cpt__subitem.active').attr('data-start') == 'true'){
                    $('.myAccount__start').addClass('active');
                }else{
                    $('.myAccount__start').removeClass('active');
                }
            }
            checkEmpty();
        })


        $('.floating-cpt__empty--what i').on('click', function (e){
            e.preventDefault();
            $('.floating-cpt__item.active .floating-cpt__subitem[data-start="true"]').click();
        })


        function checkEmpty(){
            let parentType = $('.floating-cpt__item.active');
            if(parentType.length > 0) {
                if (parentType.find('.floating-cpt__content--item.active .search__item:not(.hide)').length > 0) {
                    $('.floating-cpt__empty').removeClass('active');
                } else {
                    $('.floating-cpt__empty').addClass('active');
                }

                $('.floating-cpt__empty--title i').html(parentType.attr('data-title'));
                $('.floating-cpt__empty--title span, .floating-cpt__empty--what span').html(parentType.find('.floating-cpt__subitem.active').text().toLowerCase());

                if(parentType.find('.floating-cpt__subitem[data-start="true"]').length > 0){
                    $('.floating-cpt__empty--what').removeClass('hide')
                }else{
                    $('.floating-cpt__empty--what').addClass('hide')
                }

                if(parentType.find('.floating-cpt__subitem.active[data-start="true"]').length == 1){
                    $('.floating-cpt__empty').removeClass('active');
                }
            }
        }

        function countSearchItem(){
            $('.floating-cpt__item').each(function (i,e){
                let parent = $(this);
                let title = $(this).attr('data-title');
                let index = $(this).index() + 1;
                if(title == 'Recently Viewed' || title == 'Suggested'){}else{
                    if($(this).find('.search__item').length == 0){
                        $(this).remove();
                        $('.floating-bar__list>div:nth-child('+index+')').remove();
                    }
                }
                if(title == 'Daf Yomi'){
                    let correct = title == 'Daf Yomi' ? 1 : 2;
                    let findIndex = 0;
                    $(this).find('.floating-cpt__content--item').each(function(ii,ee){
                        if(findIndex == 0 && $(this).find('.search__item').length > 0){
                            findIndex = $(this).index() + correct;
                            $(this).addClass('active');
                            parent.find('.floating-cpt__subitem').removeClass('active');
                            parent.find('.floating-cpt__subitem:nth-child('+findIndex+')').addClass('active');
                        }
                    })
                }
            })

          if($('.myAccount__subtab:first-child .myAccount__subtab--item[data-start="true"]').length == 0 ){
              $('.myAccount__subtab:first-child .myAccount__subtab--item:first-child').click();
          }

            // $('.myAccount__list--maintab:nth-child(3)').each(function (i,e){
            //     let findIndex = 0;
            //     let parentIndex = $(this).index() + 1;
            //     let parent = $(this);
            //     $(this).find('.myAccount__list--subtab').each(function(ii,ee){
            //         if(findIndex == 0 && $(this).find('.search__item').length > 0){
            //             findIndex = $(this).index() + 2;
            //             parent.find('.myAccount__list--subtab').removeClass('active');
            //             $('.myAccount__subtab:nth-child('+parentIndex+') .myAccount__subtab--item:nth-child('+findIndex+')').click();
            //             $(this).addClass('active');
            //         }
            //     })
            // });
        }
    }
}